import { render, staticRenderFns } from "./TicketEditTabInfo.vue?vue&type=template&id=16e98d7a&"
import script from "./TicketEditTabInfo.vue?vue&type=script&lang=js&"
export * from "./TicketEditTabInfo.vue?vue&type=script&lang=js&"
import style0 from "./TicketEditTabInfo.vue?vue&type=style&index=0&id=16e98d7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports